













































































































import moment from 'moment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Booking } from '@/api';
import { apiBase, apiNamespace } from '@/config';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) readonly startDate: string;
  @Prop({ required: true }) readonly endDate: string;

  loading: boolean = false;

  bookings: Booking[] = [];

  formatDate(date: string) {
    return moment(date).format('D/MM/YYYY');
  }

  formatTime(date: string) {
    return moment(date).format('HH:mm');
  }

  invoiceUrl(booking: Booking) {
    return apiBase + apiNamespace + '/bookings/' + booking.id + '/invoice/';
  }

  async getReportData() {
    try {
      this.loading = true;
      this.bookings = (
        await Booking.includes(['airlineOut', 'airlineIn', 'lot'])
          .where({
            extras__isnull: false,
            end_datetime__gte: this.startDate,
            end_datetime__lte: this.endDate,
            status: 'complete',
          })
          .order({ endDatetime: 'asc' })
          .includes('extras')
          .per(1000)
          .all()
      ).data;
    } catch (e) {
      // Error
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.getReportData();
  }

  @Watch('startDate')
  @Watch('endDate')
  dateChanged() {
    this.getReportData();
  }
}
